/**
 * Checks the device resolution/touch
 * -----------------------------------------------------------------------------
 *
 * Ensures that we always know if we are using a Touch, Mobile, Tablet, or Desktop device.
 *
 * if (resolution.isMobile) {}
 *
 * It refreshes dynamically. We can also check when that happens by using the onChange method:
 *
 * resolution.onChange(() => {
 *  // only triggers once when we hop between different media screen sizes
 *  // for example, from Mobile(<= 768px) to Tablet(>= 769px and <=1100px)
 *  // or from Tablet(>= 769px and <=1100px) to Desktop(>=1101px)
 *
 *  if (resolution.isMobile() || resolution.isTouch()) {}
 * });
 *
 */

export default function resolution() {
  const touchQuery = `(any-pointer: coarse)`;
  const mobileQuery = `(max-width: ${window.theme.sizes.medium}px)`;
  const tabletQuery = `(min-width: ${window.theme.sizes.medium + 1}px) and (max-width: ${window.theme.sizes.large}px)`;
  const desktopQuery = `(min-width: ${window.theme.sizes.large + 1}px)`;

  resolution.isTouch = () => {
    const touchMatches = window.matchMedia(touchQuery).matches;
    document.documentElement.classList.toggle('supports-touch', touchMatches);
    return touchMatches;
  };
  resolution.isMobile = () => window.matchMedia(mobileQuery).matches;
  resolution.isTablet = () => window.matchMedia(tabletQuery).matches;
  resolution.isDesktop = () => window.matchMedia(desktopQuery).matches;

  const queries = [
    [touchQuery, resolution.isTouch],
    [mobileQuery, resolution.isMobile],
    [tabletQuery, resolution.isTablet],
    [desktopQuery, resolution.isDesktop],
  ];

  resolution.onChange = (callback) => {
    queries.forEach((query) => {
      window.matchMedia(query[0]).addEventListener('change', () => {
        if (query[1]() && callback) callback();
      });
    });
  };
}

resolution();
